const INBOUND_STATUS_CODES = new Set(['inbound', 'inbound_driver']);
const OUTBOUND_STATUS_CODES = new Set(['outbound', 'outbound_driver']);

export function scheduleDateIso(row) {
  if (!row?.schedule_date) return '';
  return typeof row.schedule_date === 'string'
    ? row.schedule_date.slice(0, 10)
    : String(row.schedule_date).slice(0, 10);
}

function buildEmployeeScheduleIndex(rangeRows) {
  const byEmployee = new Map();
  (rangeRows || []).forEach((row) => {
    const id = row.employee_id;
    if (id == null) return;
    if (!byEmployee.has(id)) byEmployee.set(id, []);
    byEmployee.get(id).push(row);
  });
  byEmployee.forEach((rows) => {
    rows.sort((a, b) => scheduleDateIso(a).localeCompare(scheduleDateIso(b)));
  });
  return byEmployee;
}

export function findNextInboundDate(rows, viewDate) {
  if (!rows?.length || !viewDate) return null;
  for (const row of rows) {
    const d = scheduleDateIso(row);
    if (d < viewDate) continue;
    const code = (row.status_code || '').toLowerCase();
    if (INBOUND_STATUS_CODES.has(code)) return d;
  }
  return null;
}

export function findNextOutboundDate(rows, viewDate) {
  if (!rows?.length || !viewDate) return null;
  for (const row of rows) {
    const d = scheduleDateIso(row);
    if (d <= viewDate) continue;
    const code = (row.status_code || '').toLowerCase();
    if (OUTBOUND_STATUS_CODES.has(code)) return d;
  }
  return null;
}

export function formatNextMovementLabel(type, dateIso, viewDate) {
  if (!dateIso || !type) return null;
  if (dateIso === viewDate) {
    return type === 'outbound' ? 'Out today' : 'In today';
  }
  const [y, m, d] = dateIso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  const label = dt.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
  return type === 'outbound' ? `Out ${label}` : `In ${label}`;
}

/** Attach next_movement_date + next_movement_type to each roster row for the view date. */
export function enrichRosterWithNextMovement(rosterRows, scheduleRangeRows, viewDate) {
  const index = buildEmployeeScheduleIndex(scheduleRangeRows);
  return (rosterRows || []).map((person) => {
    const employeeRows = index.get(person.employee_id) || [];
    const onSite = person.is_on_site === true;
    const nextDate = onSite
      ? findNextOutboundDate(employeeRows, viewDate)
      : findNextInboundDate(employeeRows, viewDate);
    return {
      ...person,
      next_movement_date: nextDate,
      next_movement_type: onSite ? 'outbound' : 'inbound',
    };
  });
}
